import { render, staticRenderFns } from "./Impersonate.vue?vue&type=template&id=a261d3a6&"
import script from "./Impersonate.vue?vue&type=script&lang=js&"
export * from "./Impersonate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports